import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface TopSkillsTableProps {
  skillFrequency: Record<string, number>;
  memberCount: number;
}

export function TopSkillsTable({ skillFrequency, memberCount }: TopSkillsTableProps) {
  const sorted = Object.entries(skillFrequency)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 20);

  const maxCount = sorted.length > 0 ? sorted[0][1] : 1;

  if (sorted.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm">Top Skills</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No skill data yet.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Top Skills (Team of {memberCount})</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {sorted.map(([skill, count]) => (
            <div key={skill} className="flex items-center gap-3">
              <span className="w-40 truncate text-xs font-medium">{skill}</span>
              <div className="flex-1">
                <div className="h-2 rounded-full bg-muted">
                  <div
                    className="h-2 rounded-full bg-primary"
                    style={{ width: `${(count / maxCount) * 100}%` }}
                  />
                </div>
              </div>
              <span className="w-16 text-right text-xs text-muted-foreground">
                {count}/{memberCount}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
